import { asDate } from "../state/types";

function apiTransportDateToDate(value: any) {
    return value ? new Date(value + "Z") : null; // YYYY-MM-ddTHH:mm:ss expected
}

function dateToApiTransportDate(value: any) {
    const isoDate = asDate(value)?.toISOString();
    return isoDate?.slice(0, 10);
}


export {
    apiTransportDateToDate,
    dateToApiTransportDate
}